<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_xviii"></a><a id="page_xix"></a><a id="abb"></a><span class="big">A</span><span class="space">Abbreviations</span></h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="25%"/>
<col width="75%"/>
</colgroup><tbody><tr>
<td><p class="tablex"><strong>AMNH</strong></p></td>
<td><p class="tabley">American Museum of Natural History, New York, New York</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>ANSP</strong></p></td>
<td><p class="tabley">Academy of Natural Sciences of Philadelphia, Philadelphia, Pennsylvania</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>CMC</strong></p></td>
<td><p class="tabley">Cincinnati Museum Center, Cincinnati, Ohio</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>CMNH</strong></p></td>
<td><p class="tabley">Carnegie Museum of Natural History, Pittsburgh, Pennsylvania</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>DMNH/DMNS</strong></p></td>
<td><p class="tabley">Denver Museum of Nature and Science, Denver, Colorado</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>ESU</strong></p></td>
<td><p class="tabley">Emporia State University Geology Museum, Emporia, Kansas</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>FFHM</strong></p></td>
<td><p class="tabley">Fick Fossil and History Museum, Oakley, Kansas</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>FHSM</strong></p></td>
<td><p class="tabley">Sternberg Museum of Natural History, Fort Hays State University, Hays, Kansas</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>FMNH</strong></p></td>
<td><p class="tabley">The Field Museum of Natural History, Chicago, Illinois</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>KU</strong></p></td>
<td><p class="tabley">University of Kansas Invertebrate Paleontology Collection, Lawrence, Kansas</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>KUVP</strong></p></td>
<td><p class="tabley">University of Kansas Vertebrate Paleontology Collection, Lawrence, Kansas</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>LACMNH</strong></p></td>
<td><p class="tabley">Los Angeles County Museum of Natural History, Los Angeles, California</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>MCZ</strong></p></td>
<td><p class="tabley">Museum of Comparative Zoology, Harvard, Cambridge, Massachusetts</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>NAMAL</strong></p></td>
<td><p class="tabley">North American Museum of Ancient Life, Lehi, Utah</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>NJSM</strong></p></td>
<td><p class="tabley">New Jersey State Museum, Trenton, New Jersey</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>RMDRC</strong></p></td>
<td><p class="tabley">Rocky Mountain Dinosaur Resource Center, Woodland Park, Colorado</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>ROM</strong></p></td>
<td><p class="tabley">Royal Ontario Museum, Toronto, Ontario, Canada</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>SDSMT</strong></p></td>
<td><p class="tabley">South Dakota School of Mines and Technology, Rapid City, South Dakota</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>UCM</strong></p></td>
<td><p class="tabley">University of Colorado Museum, Boulder, Colorado</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>UNO</strong></p></td>
<td><p class="tabley">University of New Orleans, New Orleans, Louisiana</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>UPI</strong></p></td>
<td><p class="tabley">Uppsala Paleontological Institute, Uppsala University, Sweden</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>UNSM</strong></p></td>
<td><p class="tabley">University of Nebraska State Museum, Lincoln, Nebraska</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>USNM</strong></p></td>
<td><p class="tabley">United States National Museum, Washington, D.C.</p></td>
</tr>
<tr>
<td><p class="tablex"><strong>YPM</strong></p></td>
<td><p class="tabley">Yale Peabody Museum, New Haven, Connecticut</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?3c7db9d8